// src/components/UserSettingsModal.js
import React, { useState } from "react";
import { auth } from "../firebase";
import { deleteUser, signOut } from "firebase/auth";

function UserSettingsModal({ user, onClose, isProcessing = false }) {
  const [error, setError] = useState("");

  const handleSignOut = async () => {
    setError("");
    try {
      await signOut(auth);
      onClose();
    } catch (err) {
      setError(err.message);
    }
  };

  const handleDeleteAccount = async () => {
    setError("");
    try {
      if (window.confirm("¿Estás seguro de eliminar tu cuenta? Esta acción no se puede deshacer.")) {
        await deleteUser(user);
        alert("Cuenta eliminada correctamente.");
        onClose();
      }
    } catch (err) {
      setError(err.message);
    }
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4"
      onClick={handleOverlayClick}
    >
      <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" />
      <div className="relative bg-white p-8 rounded-2xl shadow-2xl w-full max-w-md">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-2xl font-bold text-gray-800">Ajustes de Usuario</h2>
          <button
            type="button"
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
            disabled={isProcessing}
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {error && <p className="text-red-500 mb-4">{error}</p>}

        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-gray-700">Nombre de usuario</label>
            <input
              type="text"
              value={user.displayName || ""}
              disabled
              className="w-full border-2 border-gray-200 p-3 rounded-xl bg-gray-100 cursor-not-allowed"
            />
          </div>

          <div>
            <label className="text-sm font-medium text-gray-700">Correo electrónico</label>
            <input
              type="email"
              value={user.email}
              disabled
              className="w-full border-2 border-gray-200 p-3 rounded-xl bg-gray-100 cursor-not-allowed"
            />
          </div>

          <div className="flex gap-3 pt-4">
            <button
              type="button"
              onClick={handleSignOut}
              className="flex-1 bg-gray-100 text-gray-700 px-4 py-3 rounded-xl font-medium hover:bg-gray-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={isProcessing}
            >
              Cerrar sesión
            </button>
            <button
              type="button"
              onClick={handleDeleteAccount}
              className="flex-1 bg-red-500 text-white px-4 py-3 rounded-xl font-semibold hover:bg-red-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={isProcessing}
            >
              Eliminar cuenta
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UserSettingsModal;
